<template>
  <div v-if="shouldShow" class="input-semantico">
    <label for="flagSemantico">Pesquisa por assunto:</label>
    <input
      type="checkbox"
      id="flagSemantico"
      :checked="checked"
      @change="toggleCheckbox"
    />
    <ModalNovidade
      :index="1"
      label-text="Novidade"
      message="Novidade! Nova opção de busca. Agora você pode pesquisar por assuntos relacionados à legislação, atos infralegais e mensagens de veto utilizando linguagem natural (Ex.: Quais os direitos dos autistas?). Experimente marcar a caixa de seleção ao lado para explorar essa funcionalidade."
      :data-inicio="'2025-09-17'"
      :data-fim="'2025-10-31'"
    />
  </div>
</template>

<script>
import ModalNovidade from "./ModalNovidade.vue";
export default {
  name: "InputSemantico",
  props: {
    statusNorma: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalNovidade,
  },
  computed: {
    shouldShow() {
      return this.statusNorma === 'ok' || process.env.NODE_ENV === 'development';
    }
  },
  data() {
    return {
      checked: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.checked = newVal;
    },
  },
  methods: {
    toggleCheckbox(event) {
      this.checked = event.target.checked;
      this.$emit("input", this.checked);
    },
  },
};
</script>

<style>
.input-semantico {
  display: flex;
  width: fit-content;
  gap: 0.7rem;
  margin-bottom: 0.5rem;

  label {
    width: max-content;
    font-size: 1.2rem;
    color: #ffa900;
  }
  input {
    width: 1rem;
    height: auto;
    aspect-ratio: 1;
    padding: 0;
    margin: 0;
  }
}
</style>
